import { countrySchema } from '@/common/constants/country-list';
import { MARKET, TMarket } from '@/common/constants/markets';
import { requiredString } from '@/common/utils/zod';
import { z } from 'zod';

export const getAddressFormSchema = (market: TMarket) =>
  z.object({
    address: requiredString,
    zipCode: requiredString.max(8, 'errors.input.invalid_zipcode'),
    city: requiredString,
    province: market === MARKET.PT ? z.string().optional() : requiredString,
    country: countrySchema,
    shareWithInsurer: z.boolean().optional(),
  });

export type TAddressFormValues = z.infer<
  ReturnType<typeof getAddressFormSchema>
>;
